import { Button, ButtonProps } from '@cast/design-system';

type Props = Omit<ButtonProps, 'children' | 'testId'>;

export const IRanTheScriptButton = (props: Props) => (
  <Button {...props} testId="i-ran-the-script-button">
    I ran the script
  </Button>
);
